import React from 'react';
import PropTypes from 'prop-types';

import Apps from './Apps';
import Awards from './Awards';
import BackToTop from './BackToTop';
import Copyright from './Copyright';
import SwitchToDesktop from '../containers/SwitchToDesktop';
import SwitchToMobile from '../containers/SwitchToMobile';
import CorporateList from './CorporateList';
import FreeHtml from 'apps/scribe/FreeHtml';
import Links from '[theme-lib]/apps/footer/containers/Links';
import SocialMedia from './SocialMedia';

import { msg } from 'api';

export default function Footer(props) {
  const { show, socialLinks, appLinks, mhraLogo, cookieLink, copyrightText, footerLogo } = props;

  if (!show) {
    return null;
  }

  const msgs = msg.footers.footer || {};

  return (
    <footer className="ft-footer">
      <div className="ft-footer__contentBottom">
        <div className="ft-footer__bottomLogo" />
        <BackToTop />
      </div>
      <div className="ft-footer__contentWrapper">
        <div className="ft-footer__content">
          <img
            src={footerLogo.image}
            alt={footerLogo.altText}
            className="ft-footer__logoImg"
          />
          <SwitchToMobile />
          <SocialMedia socialLinks={socialLinks} />
          <Apps appLinks={appLinks} />
          <Awards
            findOutMore={msgs.findOutMore}
            findOutMoreLink={msgs.findOutMoreLink}
          />
          <hr />
          <Links />
          {mhraLogo && <FreeHtml html={mhraLogo} />}
          <p className="ft-footer__request">
            {msgs.productRequestText} <a
              href="/webshop/productRequestEdit.do"
              className="ft-footer__link ft-footer__requestLink"
            >{msgs.productRequestLink}</a>
          </p>
          <hr />
          <div className={`ft-corporate ${mhraLogo && 'ft-corporate--mhra'}`}>
            <div className="ft-corporate__text">
              <SwitchToDesktop />
              <Copyright copyrightText={copyrightText || msgs.copyright} />
              <CorporateList cookieLink={cookieLink} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  appLinks: PropTypes.array.isRequired,
  cookieLink: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
  }),
  footerLogo: PropTypes.object,
  mhraLogo: PropTypes.string,
  socialLinks: PropTypes.array.isRequired,
  show: PropTypes.bool.isRequired,
};
